import { Dialog } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import CenteredModal from "./CenteredModal";
import AppButton from "../buttons/AppButton";
type AlertProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};
export default function RequestChangeAppointmentModal(props: AlertProps) {
  const { isOpen, onClose, onConfirm } = props;
  const LocalBasePath = "page.alert";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <CenteredModal setOpen={onClose} open={isOpen}>
      <div className="sm:w-[512px] ">
        <div className="mb-3 bg-white">
          <div className="sm:flex sm:items-start">
            <div className="flex flex-col w-full">
              <Dialog.Title
                as="h3"
                className="flex gap-3 text-sm font-medium text-yellow-800"
              >
                <ExclamationIcon
                  className="w-6 h-6 text-yellow-400"
                  aria-hidden="true"
                />
                {t("payAttention")}
              </Dialog.Title>
              <div className="mt-2 mb-2 rtl:pr-8 sm:mb-0 ltr:pl-8">
                <p className="flex justify-start w-full text-base text-gray-500">
                  {t("requestChangeConfirm")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row-reverse">
          <AppButton onClick={() => onConfirm()} buttonShape="primary-danger">
            {t("confirmReschedule")}
          </AppButton>
          <AppButton onClick={() => onClose()} buttonShape="secondary">
            {t("cancel")}
          </AppButton>
        </div>
      </div>
    </CenteredModal>
  );
}
